/** Shared early warning / early detection marker styling (map pins + UI badges). */
export const ALERT_MARKER_KINDS = {
  ew: { icon: "⚠️", color: "#dc2626", label: "Early Warning" },
  ed: { icon: "🔍", color: "#d97706", label: "Early Detection" },
};
